// extracted by mini-css-extract-plugin
export default {"headingText":"devices_headingText__f++Ex","card":"devices_card__z8l3D"};